import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration
// Uses build-time environment variables (REACT_APP_FIREBASE_*) when available,
// falls back to sandbox defaults for local development.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAoB5y6Zwn4GofO6mNRM2fLnSr5CAvol4Y",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "pitto-authentication.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "pitto-authentication",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "pitto-authentication.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "492814511728",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:492814511728:web:371ae2ccbf3986dd98ceb5",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

export default app;

